import { render, staticRenderFns } from "./InvoicePaymentMethodChip.vue?vue&type=template&id=a2ac54a6&"
import script from "./InvoicePaymentMethodChip.vue?vue&type=script&lang=ts&"
export * from "./InvoicePaymentMethodChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports